import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Icon } from '@marvelapp/ballpark-components';
// eslint-disable-next-line mobx/missing-observer
export default function StartRecording() {
    return (_jsx(Icon, { height: 30, viewBox: "0 0 30 30", width: 30, children: _jsx("circle", { cx: "15", cy: "15", fillRule: "evenodd", r: "6" }) }));
}
